import React, { Component } from "react";
import axios from "axios";
import User from "./User";
const config = require("../config.json");

export default class UserAdmin extends Component {
  state = {
    users: [],
    campaigns: [],
    loading: false,
  };

  fetchCampaigns = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/campaign/active`);
      const campaigns = res.data;
      this.setState({ campaigns: campaigns });
    } catch (err) {
      console.log(err);
    }
  };

  fetchUsers = async (campaignId) => {
    let lastEvaluatedKey = "";
    let isDone = false;
    this.setState({ loading: true, users: [] });

    while (!isDone) {
      if (campaignId) {
        try {
          const res = await axios.post(
            `${config.api.invokeUrl}/campaign/${campaignId}/users`,
            { lastEvaluatedKey }
          );

          if (res.data.lastEvaluatedKey) {
            lastEvaluatedKey = res.data.lastEvaluatedKey;
          } else {
            isDone = true;
            this.setState({ loading: false });
          }

          const users = [...this.state.users, ...res.data.users];

          this.setState({ users });
        } catch (err) {
          isDone = true;
          this.setState({ loading: false });
          console.log(err);
        }
      } else {
        return;
      }
      //reqwqer
    }
  };

  deleteUser = async (userId, userEmail) => {
    try {
      await axios.delete(
        `${config.api.invokeUrl}/users?email=${encodeURIComponent(
          userEmail
        )}&id=${userId}`
      );
      this.setState({
        users: this.state.users.filter((user) => {
          return user.id != userId;
        }),
      });
    } catch (error) {
      console.log(error);
    }
  };

  componentDidMount = async () => {
    await this.fetchCampaigns();
  };

  calculateTotalPoints = (user) => {
    let totalPoints = 0;
    let categoryPoints = {};

    for (const week in user.doneActivities) {
      const weeklyDoneActivities = user.doneActivities[week];

      for (const activityId in weeklyDoneActivities) {
        const doneActivity = weeklyDoneActivities[activityId];

        let points = 0;
        if (doneActivity?.choices) {
          for (const choice in doneActivity.choices) {
            if (typeof doneActivity.choices[choice].points == "number") {
              points += doneActivity.choices[choice].points;
            } else if (typeof doneActivity.points == "number") {
              points += doneActivity.points;
            }
          }
        } else {
          if (typeof doneActivity.points == "number") {
            points = doneActivity.points;
          }
        }

        totalPoints += points;

        if (doneActivity.category) {
          if (categoryPoints[doneActivity.category]) {
            categoryPoints[doneActivity.category] += points;
          } else {
            categoryPoints[doneActivity.category] = points;
          }
        }
      }
    }

    return { categoryPoints, totalPoints };
  };

  render() {
    return (
      <>
        <section className="section">
          <div className="container">
            <h1>Bruger Admin</h1>
            <br />
            <div className="columns is-multiline">
              <div className="column">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <div className="control">
                    <select
                      className="select is-medium"
                      name="campaigns"
                      id="campaigns"
                      onChange={() => {
                        const select = document.getElementById("campaigns");
                        this.fetchUsers(
                          select.options[select.selectedIndex].value
                        );
                      }}
                    >
                      <option key={0} value=""></option>
                      <option key={1} value="all">
                        Alle
                      </option>
                      {this.state.campaigns.map((campaign) => {
                        return (
                          <option key={campaign.id} value={campaign.id}>
                            {campaign.campaignName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  {this.state.loading && (
                    <div style={{ marginLeft: 10 }} className="spinner"></div>
                  )}
                </div>
                <div className=" is-parent">
                  {this.state.users.map((user) => (
                    <User
                      user={user}
                      key={user.id}
                      isAdmin={true}
                      deleteUser={this.deleteUser}
                      calculateTotalPoints={this.calculateTotalPoints}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}
